import type { ILocation } from '@model/structureData';

export const getFacilityByGroup = (assetTreeFacilities: ILocation[], groupFacilities: Array<number>) => {
  const facilitiesByGroup: ILocation[] = [];

  for (const treeFacility of assetTreeFacilities) {
    if (groupFacilities.includes(treeFacility.id)) {
      facilitiesByGroup.push(treeFacility);
    }
  }

  return facilitiesByGroup;
};
